import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
import "./state/theme"; // apply saved theme on load
// DEV-ONLY: on /portal-preview, install the AppShell-chrome mock (fetch
// interceptor + token seed) EAGERLY — before <App/> renders and the outer
// AuthProvider fires /api/auth/me. This prevents a stale es_token from 401-ing
// against the real api and redirecting the preview to /login. installShell-
// PreviewMock self-guards on the /portal-preview path AND import.meta.env.DEV,
// so normal dev pages are untouched and the whole thing tree-shakes from prod.
import { installShellPreviewMock } from "./components/shell/shellPreviewMock";

if (import.meta.env.DEV) {
  installShellPreviewMock();
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root");

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
